<template>
  <div class="page-master" >
    <div v-if="'{}' != JSON.stringify(components) && '{}' != JSON.stringify(tablelist)" >
        <div v-show="showType == 'search'">          
          <jr-searchgroup v-model="queryParam.queryData['CT0020000000047']" :components="components['CT0020000000047']"  :badge="badge"  :selectData="selectData" @badge-click="badgeClick"></jr-searchgroup>
          <jr-button @click="query('Button')" :components="components['CT0020000000048']" :loading="queryLoding"  :badge="badge" @badge-click="badgeClick" type="primary" icon="el-icon-search">查询</jr-button>
          <jr-button @click="resetClick" :components="components['CT0020000000049']" :badge="badge" @badge-click="badgeClick" type="warning" icon="el-icon-refresh">重置</jr-button>
          <jr-buttongroup @click="createUser" :components="components['CT0020000000050']" :badge="badge" @badge-click="badgeClick" type="success" icon="el-icon-plus" :items="['复制并新增']">新增</jr-buttongroup>
          <jr-button @click="showWhereMore" :components="components['CT0020000000051']" :badge="badge" @badge-click="badgeClick" type="primary" icon="el-icon-zoom-in">更多条件</jr-button>
          <br><jr-labelwhere :queryData="queryParam.queryData" width="800px"></jr-labelwhere>
          <br><jr-bigtable :queryParam="queryParam" :tableData="tableData" :pageTotal="pageTotal" :components="tablelist['TP0000000000002']" @sort-change="sortChange" @cell-click="cellClick"></jr-bigtable>          
          
        </div>
      
        <div v-if="showType == 'input' || showType == 'edit'">
          <jr-button @click="updateButton" :components="components['CT0020000000052']" :badge="badge" @badge-click="badgeClick" type="success" icon="el-icon-edit">修改</jr-button>
          <jr-button @click="saveButton" :components="components['CT0020000000053']" :badge="badge" @badge-click="badgeClick" type="primary" icon="el-icon-save">保存</jr-button>
          <jr-button @click="showType = 'search'" :components="components['CT0020000000054']" :badge="badge" @badge-click="badgeClick" type="danger" icon="el-icon-exit">返回</jr-button>
          <br>          
          <jr-input v-model="createData['companyId']" :components="components['CT0020000000055']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['companyName']" :components="components['CT0020000000056']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['companySortname']" :components="components['CT0020000000057']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['companyMan']" :components="components['CT0020000000058']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <br>
          <jr-input v-model="createData['companyPhone']" :components="components['CT0020000000059']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['cpuId']" :components="components['CT0020000000060']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['serverKey']" :components="components['CT0020000000061']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['pdaKey']" :components="components['CT0020000000062']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <br>
          <jr-input v-model="createData['wanIp']" :components="components['CT0020000000063']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['lanIp']" :components="components['CT0020000000064']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-datetime v-model="createData['keyTime']" :components="components['CT0020000000065']" :badge="badge" @badge-click="badgeClick"></jr-datetime>
          <jr-input v-model="createData['serverVersion']" :components="components['CT0020000000066']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <br>
          <jr-input v-model="createData['pdaVersion']" :components="components['CT0020000000067']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-select v-model="createData['companyExists']" :selectData="existsType" :components="components['CT0020000000068']" :badge="badge" @badge-click="badgeClick"></jr-select>
          <jr-select v-model="createData['messageExists']" :selectData="existsType" :components="components['CT0020000000091']" :badge="badge" @badge-click="badgeClick"></jr-select>
          <jr-datetime v-model="createData['createAt']" :components="components['CT0020000000070']" :badge="badge" @badge-click="badgeClick"></jr-datetime>
          <br>
          <jr-input v-model="createData['messageHyname']" :components="components['CT0020000000092']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['messageHypass']" :components="components['CT0020000000093']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['messageYxname']" :components="components['CT0020000000094']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-input v-model="createData['messageYxpass']" :components="components['CT0020000000095']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <br>          
          <jr-inputarea v-model="createData['companyMemo']" :components="components['CT0020000000069']" :badge="badge" @badge-click="badgeClick"></jr-inputarea>          
          <jr-input v-model="createData['pdaMaxVersion']" :components="components['CT0020000000096']" :badge="badge" @badge-click="badgeClick"></jr-input>
          <jr-datetime v-model="createData['updateAt']" :components="components['CT0020000000071']" :badge="badge" @badge-click="badgeClick"></jr-datetime>
         
          <!-- <br><jr-bigitemtable :queryParam="queryItemParam" :tableData="tableItemData" :pageTotal="pageItemTotal" :pagination="false" :components="tableitemlist['TP0000000000002']" @sort-change="sortChange" @cell-click="cellClick"></jr-bigitemtable> -->
          <br><jr-button @click="delItem" :components="components['CT0020000000090']" :badge="badge" @badge-click="badgeClick" type="danger" size='mini' icon="el-icon-delete">删除</jr-button>
          <br><jr-bigitemtable :itemPrimaryId="itemPrimaryId" :queryParam="queryItemParam" :tableItemData="tableItemData" :components="tablelist['TP0000000000003']" :readOnly="tableItemReadonly" @selection-change="selectionChange"></jr-bigitemtable>
        </div>
        <jr-wheremore v-model="queryParam.queryData" :showDialog="showDialog" :components="components" :badge="badge" ref="wheremore" @badge-click="badgeClick"></jr-wheremore>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import { initpage } from '@/api/pagetable'
import { saveKeyLicense, getKeyLicenseById } from '@/api/keylicence'
import { query } from '@/api/public'
import JRGLOBAL from '@/api/jrglobal'
import { Notification } from 'element-ui'
export default {
  name: 'KeyLicence',
  deactivated(){
    if(store.getters.closePageNames==this.$options.name){
        this.$destroy(this.$options.name)
    }
  },
  created() {
    this.initpage(this.$options.name)
  },
  data () {
    return {
      // 后台传递的组件对象
      components: {},
      // 表格对象的相关属性
      tablelist: {},
      // 查询页面和录入表单页面状态标识，默认search  录入input
      showType: 'search',
      // 搜索页面查询条件组件条件选项集
      selectData: [{id: 'companyName',value: '企业名称'}, {id: 'companySortname',value: '简称'}, {id: 'companyMan',value: '联系人'}, {id: 'companyPhone',value: '手机号'}],
      // 页面所有查询条件对象集合
      queryParam: {
        queryPath: '/home/keylicense/querykeylicense',
        // 查询条件相关参数
        queryData: {},
        queryLimit: {
          table: "",
          sort: "",
          order: "asc",
          offset: 0,
          limit: 100
        }
      },
      queryItemParam: {
        queryPath: '/home/keylicense/querykeylicenseitem',
        // 查询条件相关参数
        queryData: {x:
          {controlDefaultvalue: "",
          controlLiketype: "==",
          controlType: "Input",
          controlName: "companyId"}
        },
        queryLimit: {
          table: "",
          sort: "",
          order: "asc",
          offset: 0,
          limit: 100
        }
      },
      // 页面所有录入明细的对象集合
      createData: {},
      // 表格数据集
      tableData: [],
      tableItemData: [],
      // 查询按钮状态属性
      queryLoding: false,
      // 性别
      sex: JRGLOBAL.sex,
      // 是否
      yesOrno: JRGLOBAL.yesOrno,
      // 是否有效
      existsType: JRGLOBAL.existsType,
      // 更多查询条件
      showDialog: false,
      pageTotal: {},
      pageItemTotal: {},
      tableItemReadonly: true,
      //明细表主键id
      itemPrimaryId: "",
      //明细表选中对象
      itemSelected: []
      
    }
  },
  props: {
    badge: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    badgeClick(id,bv) {
      this.components[id]['controlRighttype'] = bv        
    },
    sortChange(queryLimit, queryType) {
      this.queryParam.queryLimit = queryLimit
      this.query(queryType)
    },
    cellClick(id, primaryId) {
      getKeyLicenseById(primaryId).then(res => {
        const code = res.status.code    
        if(code == 200){
          this.itemPrimaryId = primaryId
          this.saveAndUpdateType(true)
          const keyCompany = res.data.keyCompany
          this.refreshItem(keyCompany)
          const tableItemData = res.data.keyCompany.keyCompanyItemList
          this.tableItemData = JSON.parse(JSON.stringify(tableItemData))
          this.showType = 'input'
        }
      })
      .catch(error => {
        return Promise.reject('error')
      })
    },
    selectionChange(selection){
      this.itemSelected = selection      
    },
    // 页面加载
    initpage(pageName) {
      initpage(pageName).then(res => {
        const code = res.status.code    
        if(code == 200){
          const tablelist = res.data.tablelist
          tablelist.forEach(item=>{
            this.$set(this.tablelist, item.tableId, item)
          })
          // 设置默认pageSize
          this.queryParam.queryLimit.limit = this.tablelist['TP0000000000002'].tablePagesize
          const components = res.data.pagetablelist
          components.forEach(item=> {
            this.$set(this.components, item.controlId, item)
            if(item.controlGroup == 'Search' || item.controlGroup == 'SearchMore'){
              this.$set(this.queryParam.queryData, item.controlId, item)
            }
          })
          this.queryParam.queryData = JSON.parse(JSON.stringify(this.queryParam.queryData))
        }
      })
      .catch(error => {
        return Promise.reject('error')
      })
      //this.$forceUpdate()     
    },
    // 重置按钮
    resetClick() {
      this.queryParam.queryData = {}
      for(var key in this.components){
        if(this.components[key].controlGroup == 'Search' || this.components[key].controlGroup == 'SearchMore'){
          this.$set(this.queryParam.queryData, this.components[key].controlId, this.components[key])
        }
      }
      this.queryParam.queryData = JSON.parse(JSON.stringify(this.queryParam.queryData))
      this.tableData = []    
      this.pageTotal = {}
    },
    // 查询按钮
    query(type) {
      if(type ==  'None'){
        return
      }
      if(type == 'Button'){
        this.queryParam.queryLimit.offset = 0
      }
      this.queryLoding = true
      query(this.queryParam).then(res => {
        const code = res.status.code    
        if(code == 200){
          const tableData = res.data.keycompanylist           
          this.tableData = tableData
          this.pageTotal = res.total
        }
        this.queryLoding = false
      })
      .catch(error => {
        this.queryLoding = false
        return Promise.reject('error')
      })
    },
    // 新增按钮事件
    createUser() {
      this.createData = {}
      for(var key in this.components){
        if(this.components[key].controlGroup == 'Input'){
          this.$set(this.createData, this.components[key].controlName, this.components[key].controlDefaultvalue)
        }
      }
      this.createData = JSON.parse(JSON.stringify(this.createData))
      this.showType = 'input'
      this.tableItemData = []
      this.saveAndUpdateType(false)
    },
    // 显示更多查询条件窗口
    showWhereMore() {
      this.$refs.wheremore.showType()      
    },
    //保存信息
    saveButton() {
      this.createData.keyCompanyItemList = this.tableItemData
      saveKeyLicense(this.createData).then(res => {
        const code = res.status.code    
        if(code == 200){
          this.saveAndUpdateType(true)
          const keyCompany = res.data.keyCompany
          this.refreshItem(keyCompany)
          Notification.success({
            title: '保存成功！',
            duration: 1500
          })
        }
      })
      .catch(error => {
        return Promise.reject('error')
      })
    },
    //修改按钮
    updateButton() {
      this.saveAndUpdateType(false)
    },
    //删除明细按钮
    delItem() {
      if(this.itemSelected.length>0){
        let primary = ''
        this.tablelist['TP0000000000003'].tableColumns.forEach((item,index)=> {
          if(item.columnPrimary){
            primary=item.columnName
          }
        })
        var set = this.itemSelected.map(item=> item[primary])
        var resArr = this.tableItemData.filter(item=>!set.includes(item[primary]))
        this.tableItemData = resArr
        console.log(resArr)
      }else{
        Notification.warning({
            title: '请选择要删除的数据',
            duration: 1500
          })
      }
    },
    //根据单据状态自动变更修改保存按钮的状态
    saveAndUpdateType(isUpdate){
      this.tableItemReadonly = isUpdate
      this.components['CT0020000000052'].controlReadonly = !isUpdate
      this.components['CT0020000000053'].controlReadonly = isUpdate
      this.components['CT0020000000090'].controlReadonly = isUpdate
    },
    //刷新明细数据
    refreshItem(keyCompany){
      this.createData = keyCompany
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/KeyLicence.vue